module.exports = __webpack_public_path__ + "static/ui-framework-img-4d32267002ed2e0b1c47441d79ae4cf7.png";